import { defineMessages } from 'react-intl';

export const ltlShipmentsGridMessages = defineMessages({
  bolNumber: {
    id: 'OUq60h',
    description: 'BOL number column header',
    defaultMessage: 'BOL #',
  },
  proNumber: {
    id: '6Ko1bh',
    description: 'Pro number column header',
    defaultMessage: 'Pro #',
  },
  carrier: {
    id: '/Ekrm7',
    description: 'Carrier column header',
    defaultMessage: 'Carrier',
  },
  origin: {
    id: 'rBl2xY',
    description: 'Origin column header',
    defaultMessage: 'Origin',
  },
  destination: {
    id: '7ZdEmk',
    description: 'Destination column header',
    defaultMessage: 'Destination',
  },
  shipDate: {
    id: '+794lD',
    description: 'Ship date column header',
    defaultMessage: 'Ship Date',
  },
  deliveryDate: {
    id: 'tJZLMS',
    description: 'Delivery date column header',
    defaultMessage: 'Delivery Date',
  },
  weight: {
    id: 'MDN7aZ',
    description: 'Weight column header',
    defaultMessage: 'Weight',
  },
  charges: {
    id: 'zgCBhX',
    description: 'Charges column header',
    defaultMessage: 'Charges',
  },
  quoteExpiration: {
    id: 'rwN26N',
    description: 'Quote expiration date column header',
    defaultMessage: 'Quote Expires',
  },
  status: {
    id: 'eLQPek',
    description: 'Status column header',
    defaultMessage: 'Status',
  },
  actions: {
    id: 'Tv9I/4',
    description: 'Actions column header',
    defaultMessage: 'Actions',
  },
  track: {
    id: 'SglFr6',
    description: 'Track button label',
    defaultMessage: 'Track',
  },
  cancel: {
    id: '0GT0SI',
    description: 'Cancel button label',
    defaultMessage: 'Cancel',
  },
  downloadBol: {
    id: '31KxVA',
    description: 'Download BOL button label',
    defaultMessage: 'Download BOL',
  },
  noShipmentsTitle: {
    id: 'x215Fn',
    description: 'LTL shipments grid empty state title',
    defaultMessage: 'No freight shipments',
  },
  noShipmentsDescription: {
    id: 'ZHkEYe',
    description: 'LTL shipments grid empty state description',
    defaultMessage: 'Create your first freight quote to get started',
  },
  noProviderTitle: {
    id: '5jEKhS',
    description: 'Title shown when no freight provider is connected',
    defaultMessage: 'Connect a freight provider to get started',
  },
  noProviderDescription: {
    id: 'Ghi4U5',
    description: 'Description shown when no freight provider is connected',
    defaultMessage: 'Set up a freight provider in settings to start creating quotes',
  },
  noProviderButton: {
    id: 'l80sHp',
    description: 'Button text to navigate to freight provider settings',
    defaultMessage: 'Connect Provider',
  },
  loading: {
    id: 'rcvLGv',
    description: 'Loading state for shipments grid',
    defaultMessage: 'Loading...',
  },
});
